var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-badge',{attrs:{"count":_vm.recordList.length!==0?_vm.recordList.length + '条待处理':0,"offset":[-15,3]}},[_c('link-button',{staticStyle:{"margin-left":"50px"},on:{"click":function($event){return _vm.$refs.couponPendingList.showModal(_vm.recordList)}}},[_vm._v("消费券核销")]),_c('coupon-pending-list',{ref:"couponPendingList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }